import { createStore } from "vuex";
import axios from 'axios';
import api from '../api';

export default createStore({
  state: {
    jury: null,
    juryToken: localStorage.getItem('jury_token') || null,
    candidates: [],
    selectedCandidate: null,
    criteriasByCategory: [],
    locale: localStorage.getItem('user_locale') || 'fr',
  },
  mutations: {
    setJury(state, jury) {
      state.jury = jury;
    },
    setJuryToken(state, token) {
      state.juryToken = token;
      if (token) {
        localStorage.setItem('jury_token', token);
        // Set axios default header
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } else {
        localStorage.removeItem('jury_token');
        delete axios.defaults.headers.common['Authorization'];
      }
    },
    setCandidates(state, candidates) {
      state.candidates = candidates;
    },
    setSelectedCandidate(state, candidate) {
      state.selectedCandidate = candidate;
    },
    setCriteriasByCategory(state, criterias) {
      state.criteriasByCategory = criterias;
    },
    setLocale(state, locale) {
      state.locale = locale;
      localStorage.setItem('user_locale', locale);
    },
  },
  actions: {
    updateJury({ commit }, jury) {
      commit('setJury', jury);
    },
    updateJuryToken({ commit }, token) {
      commit('setJuryToken', token);
    },
    updateCandidates({ commit }, candidates) {
      commit('setCandidates', candidates);
    },
    updateSelectedCandidate({ commit }, candidate) {
      commit('setSelectedCandidate', candidate);
    },
    updateCriteriasByCategory({ commit }, criterias) {
      commit('setCriteriasByCategory', criterias);
    },
    updateLocale({ commit }, locale) {
      commit('setLocale', locale);
    },
    async restoreSession({ commit, state }) {
      const token = state.juryToken;
      
      if (!token) {
        return false;
      }

      try {
        // Set the token in axios headers before making the request
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Fetch current jury data from backend
        const response = await axios.get(api.juryMe);
        
        if (response.data.success) {
          commit('setJury', response.data.data);
          return true;
        } else {
          // If response is not successful, clear token
          commit('setJuryToken', null);
          commit('setJury', null);
          return false;
        }
      } catch (error) {
        console.error('Failed to restore session:', error);
        // If token is invalid, clear it
        commit('setJuryToken', null);
        commit('setJury', null);
        return false;
      }
    },
    logout({ commit }) {
      commit('setJury', null);
      commit('setJuryToken', null);
      commit('setSelectedCandidate', null);
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.juryToken,
    currentJury: (state) => state.jury,
  },
});